export const validateSPBTableInterface = () => {
    const isWidthEqual2000 = servObj.tableSize.tableWidth.current == 2000;
    const isDepthEqual500 = servObj.tableSize.tableDepth.current == 500;
    const isDepthEqual700 = servObj.tableSize.tableDepth.current == 700;

    document
        .querySelector('input[name="table_width"][value="2000"]')
        .parentNode.classList.toggle("disable", isDepthEqual500);

    document
        .querySelector("input[name='polka_depth'][value='dsp_600']")
        .parentNode.classList.toggle("disable", isDepthEqual500);
    document
        .querySelector("input[name='polka_depth'][value='dsp_800']")
        .parentNode.classList.toggle("disable", isDepthEqual500 || isDepthEqual700);
    document
        .querySelector("input[name='polka_depth'][value='metall_500']")
        .parentNode.classList.toggle("disable", isDepthEqual500);

    document
        .querySelector("input[name='shelf_for_equipment'][value='left']")
        .parentNode.parentNode.parentNode.parentNode.classList.toggle("disable", isDepthEqual500);

    document
        .querySelector('input[name="table_depth"][value="500"]')
        .parentNode.classList.toggle("disable", isWidthEqual2000 && !isDepthEqual500);

    document.getElementById("tumba_podvesnaya").classList.toggle("disable", isDepthEqual500);

    if (isWidthEqual2000 && isDepthEqual500) {
        document.querySelector('input[name="table_depth"][value="700"]').checked = true;
    }
};
